'use client'
import { Button, Col, Row } from "antd";
import styles from "./index.module.scss";
import { RightOutlined } from "@ant-design/icons";
import lastServicePic from "@/assets/images/about/lastServicePic.png";
import { map } from "lodash";
import { registerUrl } from "@/constants/api";
export default function LastService({
  titList01,
  buttonText = "立即体验",
  btnLink = registerUrl,
}: {
  titList01?: string[];
  buttonText?: string;
  btnLink?: string;
}) {
  return (
    <div className={styles.lastService}>
      <div className="wrapper hCenter">
        <Row align={"middle"}>
          <Col lg={12} xs={24} sm={24} md={24}>
            <div className={styles.leftCont}>
              <div className={styles.titleWrapper}>
                {titList01 && titList01.length > 0 ? (
                  map(titList01, (title) => {
                    return <h6>{title}</h6>;
                  })
                ) : (
                  <h6>“全景化”智能协同工作平台</h6>
                )}
              </div>
              <Button
                type="primary"
                className={styles.soonUseBtn}
                onClick={() => {
                  location.href = btnLink;
                }}
              >
                {buttonText}
                <span className={styles.arrow}>
                  <RightOutlined style={{ color: "#fff" }} />
                </span>
              </Button>
            </div>
          </Col>
          <Col lg={12} xs={24} sm={24} md={24}>
            <img src={lastServicePic.src} className={styles.pic} />
          </Col>
        </Row>
      </div>
    </div>
  );
}
